
export const loginAdmin = (token: string) => {

  console.log('token', token);
  return {
    type: "LOGIN",
    payload: { "token": token },
  };
};
